/**
 * @generated SignedSource<<95f1026434793df353f849ec59749a29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type status_softwareReleasesVersionDetailIssueList$data = {
  readonly status: {
    readonly description: string | null | undefined;
    readonly name: string;
    readonly statusCategory: {
      readonly statusCategoryId: string;
    };
  };
  readonly " $fragmentType": "status_softwareReleasesVersionDetailIssueList";
};
export type status_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: status_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"status_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "status_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "status.name"
          },
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "statusCategoryId"
                  },
                  "action": "THROW",
                  "path": "status.statusCategory.statusCategoryId"
                }
              ]
            },
            "action": "THROW",
            "path": "status.statusCategory"
          }
        ]
      },
      "action": "THROW",
      "path": "status"
    }
  ],
  "type": "JiraStatusField"
};

(node as any).hash = "5e65ebd3a202999e9094506fd6a31982";

export default node;
